import React from 'react';

import { LockProvider } from '@work4all/components/lib/hooks';
import {
  INavigationOverlayProps,
  NavigationOverlay,
} from '@work4all/components/lib/navigation/navigation-overlay';

import { ObjectTypesUnion } from '@work4all/models';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { MaskControllerProps } from '../../containers/mask-overlays/mask-overlay';
import { getMaskControllerComponent } from '../../containers/mask-overlays/mask-overlay/utils/get-mask-controller-component';
import { TicketOverlayControllerProps } from '../../containers/mask-overlays/mask-overlay/views/ticket/TicketOverlayController';

interface MaskDialogOverlayProps
  extends Omit<INavigationOverlayProps, 'initialView'>,
    MaskControllerProps,
    TicketOverlayControllerProps {
  entity: Entities;
  forcedObjectType?: ObjectTypesUnion;
}

const MaskDialogOverlayBase: React.FC<MaskDialogOverlayProps> = (props) => {
  const MaskComponent = getMaskControllerComponent(props.entity);
  const initialView = {
    view: <MaskComponent {...props} />,
  };

  return (
    <LockProvider
      entityIds={[props.id]}
      entity={props.entity}
      autoLock={!!props.id}
      forcedObjectType={props.forcedObjectType}
    >
      <NavigationOverlay initialView={initialView} {...props} />;
    </LockProvider>
  );
};

export const MaskDialogOverlay = React.memo(MaskDialogOverlayBase);
